export const getParams = (params = {}) => new URLSearchParams(params);

export const getStringParams = (params = {}) => getParams(params).toString();
